import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const loginStringsSG = (formValues) => {
    return new Promise((resolve, reject) => {

        var fdd = new FormData;
        fdd.append('signemail', formValues.emailId);
        fdd.append('signpassword', formValues.password);

        axios({
          method : "POST",
          url :  api_url + "/login",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const resetPassword = (formValues) => {
    return new Promise((resolve, reject) => {

        var fdd = new FormData;
        fdd.append('emailId', formValues.emailId);

        axios({
          method : "POST",
          url :  api_url + "/public/ResetPassword",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateNewPassword = (sessionId, formValues) => {
    return new Promise((resolve, reject) => {

        var fdd = new FormData;
        fdd.append('sessionId', sessionId);
        fdd.append('password', formValues.password);

        axios({
          method : "POST",
          url :  api_url + "/public/UpdateNewPassword",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const activateUser = (sessionId) => {
    return new Promise((resolve, reject) => {

        var fdd = new FormData;
        fdd.append('sessionId', sessionId);

        axios({
          method : "POST",
          url :  api_url + "/public/ActivateUser",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const handleDirectLogin = (directLoginId, directLoginEmail) => {
    return new Promise((resolve, reject) => {

        var fdd = new FormData;
        fdd.append('directLoginId', directLoginId);
        fdd.append('directLoginEmail', directLoginEmail);

        axios({
          method : "POST",
          url :  api_url + "/public/HandleDirectLogin",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const handleTinyUrl = (tinyURLId) => {
    return new Promise((resolve, reject) => {

        var fdd = new FormData;
        fdd.append('tinyURLId', tinyURLId);

        axios({
          method : "POST",
          url :  api_url + "/public/HandleTinyUrl",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}